import React, { Component } from 'react';
import './instanceScreenshotViewer.css';
import {Auth} from 'aws-amplify';
import Instances from './instances/instances';
import Sidebar from './sidebar/sidebar.js';
import Title from './title/title.js';
import utils from './util/index.js';

class InstanceScreenshotViewer extends Component {

  state = {
    instances: [],
    loading: false,
    monitoring: [],
    preferences: {
      defaultRefreshRate: '10',
      invertNavControls: false
    }
  }

  componentDidMount() {

    // Get any state from local storage.
    this.setState(JSON.parse(localStorage.getItem('instanceScreenshotViewer_state')));

    // Get all the instances that exist.
    setTimeout(() => {
      this.getAllInstances();
    }, 0);

  }

  componentDidUpdate() {
    // Update the local storage on state change.
    localStorage.setItem('instanceScreenshotViewer_state', JSON.stringify(this.state));
  }

  getAllInstances = () => {

    // Get all instances that exist in AWS accounts.

    // TODO: This should be updated to call an API via API Gateway and Lambda rather than passing credentials to a local function.

    this.setState({loading: true}, () => {

      // Credentials are obtained via Amplify and passed to the getAllInstances function.
      return Auth.currentCredentials()
      .then(res => {
        return utils.getAllInstances(Auth.essentialCredentials(res));
      })
      .then(res => {
        // When all instances are collected the state is updated.
        this.setState({instances: res, loading: false});
      })
      .catch(err => {
        console.log(err);
      });

    });

  }

  // This function adds an instance to the main dashboard so that its screenshots and maintenance can be monitored.
  addToMonitoring = instances => {

    // Ensure the instances variable is always an array.
    if (!Array.isArray(instances)) instances = [instances];

    // Get the array of currently monitored instances.
    const {monitoring} = this.state;

    // Filter out instances already being monitored and add the remaining instances to state.
    const newInstances = instances.filter(instance => {
      return !monitoring.find(monitoredInstance => monitoredInstance.InstanceId === instance.InstanceId);
    });

    this.setState({monitoring: [...monitoring, ...newInstances]});

  }

  reorderMonitoring = (instanceId, direction) => {

    const {monitoring} = this.state;

    // Get the index of the instance to move.
    const instanceIndex = monitoring.findIndex(instance => instance.InstanceId === instanceId);

    // Left most instance can't be move left, right most instance can't be moved right.
    if (!(instanceIndex === 0 && direction === '<<') && !(instanceIndex === monitoring.length - 1 && direction === '>>')) {

      // Get the new index of the instance to move and create the new array of monitored instances.
      const swapIndex = direction === '<<' ? instanceIndex - 1 : instanceIndex + 1;
      const newMonitoring = [...monitoring];
      const tempVar = newMonitoring[instanceIndex];
      newMonitoring[instanceIndex] = newMonitoring[swapIndex];
      newMonitoring[swapIndex] = tempVar;

      this.setState({monitoring: newMonitoring});

    }

  }

  removeFromMonitoring = instancesToRemove => {

    // Ensure instancesToRemove is an array.
    if (!Array.isArray(instancesToRemove)) instancesToRemove = [instancesToRemove];

    const monitoring = [...this.state.monitoring];

    // If an instance is not listed in instancesToRemove it remains, otherwise it is filtered out.
    const filteredMonitoring = monitoring.filter(monitoredInstance => {
      return !instancesToRemove.find(instanceToRemove => instanceToRemove.InstanceId === monitoredInstance.InstanceId);
    });

    this.setState({monitoring: filteredMonitoring});

  }

  removeAllFromMonitoring = () => {
    this.setState({monitoring: []});
  }

  updateScreenShotViewerState = object => {
    // A function to update the state in this component.
    this.setState(object);
  }

  render() {

    const {
      addToMonitoring,
      getAllInstances,
      removeAllFromMonitoring,
      removeFromMonitoring,
      reorderMonitoring,
      updateScreenShotViewerState
    } = this;

    const {
      instances,
      loading,
      monitoring,
      preferences
    } = this.state;

    return (
      <div className="InstanceScreenshotViewer">
        <Title
          addToMonitoring={addToMonitoring}
          instances={instances}
          preferences={preferences}
          refresh={getAllInstances}
          removeAllFromMonitoring={removeAllFromMonitoring}
          updateScreenShotViewerState={updateScreenShotViewerState}
        />
        <Sidebar
          addToMonitoring={addToMonitoring}
          instances={instances}
          loading={loading}
          monitoring={monitoring}
          removeFromMonitoring={removeFromMonitoring}
        />
        <Instances
          monitoring={monitoring}
          preferences={preferences}
          removeFromMonitoring={removeFromMonitoring}
          reorderMonitoring={reorderMonitoring}
        />
      </div>
    );
  }
}

export default InstanceScreenshotViewer;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/instanceScreenshotViewer.js